/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

import { StubUrl } from '@app/stub'
import axios from 'axios'

const url = StubUrl('Report')
export default {
  orderNote: form => axios.post(url('OrderNote'), form)
}
